const TriageRoutingIcon = ({
  fontSize,
  sx,
  style,
  className,
  width,
  height,
}) => {
  // Resolve size from MUI fontSize prop or explicit width/height
  const sizeMap = { small: 20, medium: 24, large: 35, inherit: "1em" };
  const size = width ?? height ?? (fontSize ? sizeMap[fontSize] ?? 24 : 24);
  return (
    <svg
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={1.6}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
      width={size}
      height={size}
      style={{ display: "inline-block", flexShrink: 0, ...style }}
      className={className}
    >
      <circle cx={6} cy={5} r={2} />
      <circle cx={18} cy={5} r={2} />
      <circle cx={12} cy={19} r={2} />
      <path d={"M6 7v2a4 4 0 0 0 4 4h4a4 4 0 0 1 4 4"} />
      <path d={"M18 7v2"} />
      <path d={"M12 13v4"} />
    </svg>
  );
};

export default TriageRoutingIcon;
